import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';

// The base path segments that exist within the consumer "My Account" subtree (under the
// `account/` segment). `useGoto` uses this to decide, in the consumer experience, whether to
// prepend the `account/` base (target is a consumer route) or fall back to the absolute
// SmartSend URL (target is SmartSend-only) - preventing dead `account/...` links.
//
// This is a leaf module (imports only RoutingConstants) so `use-goto.ts` can consume it
// without an import cycle (`groups/consumer.tsx` transitively imports `useGoto`).
//
// Keep in sync with `consumerRoutes` in `./consumer.tsx` (top-level routes + the
// `childrenOfSupport` segments it spreads in).
export const CONSUMER_ROUTE_SEGMENTS: readonly string[] = [
  // My Orders area
  RoutingConstants.OrderHistory,
  RoutingConstants.InTransit,
  // Account area + standalone pages
  RoutingConstants.MyDetails,
  RoutingConstants.SavedAddresses,
  RoutingConstants.Billing,
  RoutingConstants.StoredCards,
  RoutingConstants.Communications,
  RoutingConstants.PrePay,
  RoutingConstants.AutoTopUp,
  // Support area (childrenOfSupport segments reused in the consumer subtree)
  RoutingConstants.Support,
  RoutingConstants.Cancellations,
  RoutingConstants.Claims,
  RoutingConstants.SupportTickets,
  RoutingConstants.Surcharges,
  RoutingConstants.AccountConcerns
];

// True when a goTo target resolves to a route inside the consumer subtree. Compares the
// first path segment only, so nested paths (claims/:id, cancellations/request/:id?...,
// settings#tab) match their base route.
export const isConsumerRoute = (link: string): boolean => CONSUMER_ROUTE_SEGMENTS.includes(link.split(/[/#?]/)[0]);
